import React from 'react'
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

export const MsgBox = React.createClass({
  render() {
    var onok = this.props.onok
    if (!onok) {
      onok = this.props.close
    }

    return (
      <form class='modal fade form_userinfo'>
        <Modal show={this.props.showModal} onHide={this.props.close}>

          <Modal.Header closeButton>
            <Modal.Title>{this.props.caption}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div>{this.props.msg}</div>
          </Modal.Body>

          <Modal.Footer>
            {(()=>{
              if (this.props.hasCancel) {
                return (<Button class='btn btn-primary' onClick={this.props.close}>キャンセル</Button>)
              }
            })()}
            <Button type='submit' class='btn btn-primary' onClick={onok}>OK</Button>
          </Modal.Footer>

        </Modal>
      </form>
    );
  }
});



// WEBPACK FOOTER //
// ./components/msgbox.react.js